import Vue from 'vue';
import TagListPage from '../../../pages/TagListPage/TagListPage.vue';
import LoadModal from '../../../components/load-modal.vue';

export default () => {
  const view = $('.tags-index');

  new Vue({
    components: {
      TagListPage,
      LoadModal,
    },
    data: {
      initialTags: view.data('tags'),
    },
  }).$mount('#js-tag-list-page');
};
